import type { UserRow } from "design-components";
import type { UsersListSortingOrder } from "api-client";

/** Page size for settings users list API (`fromIndex` / `toIndex`). */
export const SETTINGS_USERS_LIST_PAGE_SIZE = 50;

export interface SettingsUsersState {
  rows: UserRow[];
  totalUsers: number;
  loading: boolean;
  error: string | null;
  submitting: boolean;
  submitError: string | null;
  deleteSubmitting: boolean;
  deleteError: string | null;
  firstName: string;
  lastName: string;
  emailId: string;
  fromIndex: number;
  toIndex: number;
  sortingField: string;
  sortingOrder: UsersListSortingOrder;
  /** Applied list filters (empty = no filter). Serialized to API as comma-separated `status` / `roleName`. */
  listFilterStatus: string[];
  listFilterRoleName: string[];
}

export const settingsUsersInitialState: SettingsUsersState = {
  rows: [],
  totalUsers: 0,
  loading: false,
  error: null,
  submitting: false,
  submitError: null,
  deleteSubmitting: false,
  deleteError: null,
  firstName: "",
  lastName: "",
  emailId: "",
  fromIndex: 0,
  toIndex: SETTINGS_USERS_LIST_PAGE_SIZE,
  sortingField: "firstName",
  sortingOrder: "desc",
  listFilterStatus: [],
  listFilterRoleName: [],
};
